import { queryCache, useQuery } from "react-query"

import { MediaType } from "routes/Base/Admin/GlobalMediaTypes/types"
import { Paginated } from "api/types"
import { fetchMediaConfig } from "api/media-types"
import { useParams } from "react-router-dom"
import { useSnapshot } from "valtio"
import { useTableSource } from "./TableStateProvider"

export function useDefaultFieldIds(rowId: string) {
  const { id: planId } = useParams<{ id: string }>()
  const tableSource = useTableSource()
  const readFrom = useSnapshot(tableSource.state)
  const row = readFrom[rowId]
  const mediaId =
    row?.type === "media_type_plan" ? row?.mediaId : row?.ancestorMediaId

  const ps = new URLSearchParams([
    ["configScope", "MEDIA_PLAN"],
    ["configOwnerId", planId],
  ])
  const cached = queryCache.getQueryData<Paginated<MediaType>>([
    "media-types",
    ps.toString(),
  ])
  const { data: mediaTypes } = useQuery(
    ["media-types", ps.toString()],
    fetchMediaConfig,
    {
      enabled: !cached,
      initialData: cached,
      refetchOnMount: !cached,
    },
  )
  const defaultFieldIds: Record<string, string> | undefined =
    mediaTypes?.data?.find((mt) => mt.id === mediaId)?.defaultFieldIdBySemantic

  return defaultFieldIds
}
